import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { DEVICE_SENSOR_LIST } from './url-constants';

type SensorListDataEndpointSpecification = ApiEndpointSpecification;
export const SensorListDataEndpointSpecification: SensorListDataEndpointSpecification = {
    url: DEVICE_SENSOR_LIST,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'SensorListRequestParams',
    requestBodySchemaName: 'SensorListRequestBody',
    okResponseSchemaName: 'SensorListOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:2
};

export const invokeSensorListData = Helpers.makeApiRequestFn<
    Types.SensorListRequestParams,
    Types.SensorListRequestBody,
    Types.SensorListOkresponse
>(SensorListDataEndpointSpecification);
